<template>
	<div class="general-container" style="background-color: #F1F4F8;">
		<div class="general-header mar-b-default box">
			<div class="general-box-left box">
				<div>
					<img src="../../../../common/src/assets/image/general-user.png" alt="">
				</div>
				<div class="general-header-user-account box flex-column mar-l-mini flex-justify-around">
					<p class="welcome">欢迎您回到控制台</p>
					<div class="box flex-align-end">
						<p class="email">{{userInfo.accountName | StarInfoPipe('set')}}</p>
						<div class="general-header-icon box mar-l-default">
							<efly-tooltip top="-42px" trigger="hover" left="10px" align="center" placement="top" 
							:type="(userInfo.personVeriyed === 0 && userInfo.companyVeriyed === 0) || 
							(userInfo.personVeriyed === -2 && userInfo.companyVeriyed === 0) ||
							(userInfo.personVeriyed === -1 && userInfo.companyVeriyed === 0) ||
							(userInfo.personVeriyed === -3 && userInfo.companyVeriyed === 0) ? 'danger' : 'primary'">
								<i class="icon icon-Verification color-danger"  @click="skip('/authentication')" 
								v-if="(userInfo.personVeriyed === 0 && userInfo.companyVeriyed === 0) || 
								(userInfo.personVeriyed === -1 && userInfo.companyVeriyed === 0) || 
								(userInfo.personVeriyed === -2 && userInfo.companyVeriyed === 0) ||
								(userInfo.personVeriyed === -3 && userInfo.companyVeriyed === 0)"></i>
								<i class="icon icon-Verification color-primary" @click="skip('/authenticationinfo')" v-else></i>
								<div slot="content">
									<p v-if="userInfo.personVeriyed === 0 && userInfo.companyVeriyed === 0" @click="skip('/authentication')">您还未实名认证，避免影响资源使用，请您尽快进行实名认证 <span class="tooltip-btn tooltip-btn-danger">立即实名认证</span></p>
									<p v-if="userInfo.personVeriyed === -1 && userInfo.companyVeriyed === 0">您的实名认证待审核，请稍等。</p>
									<p v-if="userInfo.personVeriyed === -2 && userInfo.companyVeriyed === 0" @click="skip('/authentication')">您实名认证失败，避免影响资源使用，请您尽快进行实名认证 <span class="tooltip-btn tooltip-btn-danger">立即实名认证</span></p>
									<p v-if="userInfo.personVeriyed === -3 && userInfo.companyVeriyed === 0">您的实名认证审核中，请稍等。</p>
									<span v-if="userInfo.personVeriyed === 1 || userInfo.companyVeriyed === 1">
										<span v-if="userInfo.companyVeriyed === 1">您已企业实名认证</span>
										<span v-else>您已个人实名认证</span>
									</span>
									<span v-if="userInfo.companyVeriyed === 0 && userInfo.companyVeriyedStatus !== 0"><span v-if="userInfo.personVeriyed === 1">，</span>您的{{userInfo.companyVeriyedStatus | companyVeriyedStatus}}</span>
								</div>
							</efly-tooltip>
							<efly-tooltip top="-42px" align="center" placement="top" type="primary">
								<div slot="content">
									<p>安全手机号：{{userInfo.phone | StarInfoPipe}}
										<!-- <span class="tooltip-btn tooltip-btn-primary">去修改</span> -->
									</p>
								</div>
								<i class="icon icon-phone2 color-primary box flex-align-end"></i>
							</efly-tooltip>
							<efly-tooltip top="-42px" align="center" placement="top" type="primary">
								<div slot="content">
									<p>注册邮箱：{{userInfo.email | StarInfoPipe('set')}}
										<!-- <span class="tooltip-btn tooltip-btn-primary">去激活</span> -->
									</p>
								</div>
								<i class="icon icon-emial-bg color-primary"></i>
							</efly-tooltip>
						</div>
					</div>
				</div>
			</div>
			<div class="general-box-right box flex-column flex-justify-center">
				<p class="mar-b-mini">
					<i class="icon icon-pending mar-r-xs"></i>
					<span>最后登录时间：{{userInfo.loginTime}}</span>
				</p>
				<p>
					<i class="icon icon-mount-ip mar-r-xs"></i>
					<span>最后登录地址：{{userInfo.loginIP}}</span>
				</p>
			</div>
		</div>
		<div class="box">
			<div class="general-box-left">
				<div class="general-content">
					<div class="general-box">
						<p class="general-title">余额概览</p>
						<div class="box">
							<div class="general-info flex-column flex-justify-center box" style="min-width: 35%;">
								<div class="general-item-box pad-b-mini">
									<span class="">可用余额：</span>
									<span class="this-month color-price">{{userBalance |money}}</span>
								</div>
								<div class="general-item-box pad-0 box flex-wrap">
									<efly-tooltip v-if="userInfo.agentID == '14416'" slot="reference"  top="-95px" left="-23px" placement="top" type="white">
                                    <div slot="content">目前暂不支持线上充值，<br/>请联系客户经理李峰<br/>联系电话：13922882080<br/>邮箱地址1：lif@efly.cc<br/>邮箱地址2：liangzh@efly.cc</div>
                                    <efly-button  size="small" class="disabled btn-price mar-r-mini mar-t-mini" @click="skip('/user/moneyset/detail')">立即充值</efly-button>
                                </efly-tooltip>
                                <efly-button v-else  size="small" class="btn-price mar-r-mini mar-t-mini" @click="skip('/user/moneyset/detail')">立即充值</efly-button>
									<efly-button size="small" class="btn-primary-bg mar-r-mini mar-t-mini" @click="skip('/user/payBill/list')">充值记录</efly-button>
									<efly-button size="small" class="btn-primary-bg mar-r-mini mar-t-mini" @click="skip('/user/bill/list')">交易明细</efly-button>
									<efly-button size="small" class="btn-primary-bg mar-t-mini" @click="skip('/user/dayConsume/list')">每日账单</efly-button>
								</div>
							</div>
							<div class="general-info box flex-column flex-justify-center" style="width: 65%;">
								<div class="general-info-content">
									<p class="mar-b-mini">余额支撑消费概况</p>
									<div class="box">
										<div style="width: 85%">
											<efly-progress :color="consumeColor" width="100%" :percentage="consumeWidth"></efly-progress>
											<div class="box flex-justify-between mar-t-xs font-small">
												<p>当前消费：<span class="color-price">{{consume.today | money}}</span> / 天</p>
												<p class="text-secondary" v-if="status.isConsume && consumeDay<1">现有余额不足1天消费</p>
												<p class="text-secondary" v-if="status.isConsume && consumeDay>=1">现有余额足够{{consumeDay || 0}}天消费</p>
												<p class="text-secondary" v-if="!status.isConsume">暂无消费</p>
											</div>
										</div>
										<span class="mar-lr-mini" :class="[consumeDay >= 3 ? 'color-success' : consumeDay === 2 ? 'color-warning' : consumeDay < 2 ? 'color-danger' : 'color-success']">
											{{consumeDay | consumeDayText}}
										</span>
										<efly-tooltip top="-28px" left="calc(100% + 2px)" placement="right">
											<div slot="content">
												<p><span class="color-point mar-r-xs color-bg-danger"></span>预警：根据日消费额，可用余额只够/不足1天消费；</p>
												<p><span class="color-point mar-r-xs color-bg-warning"></span>注意：根据日消费额，可用余额足够2天消费；</p>
												<p><span class="color-point mar-r-xs color-bg-success"></span>安全：根据日消费额，可用余额足够3天及以上消费；</p>
											</div>
											<i class="icon icon-Question color-primary"></i>
										</efly-tooltip>

									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
				<div class="general-content">
					<div class="general-box">
						<p class="general-title">
							<span>最近消费</span>
							<span class="color-primary cursor-pointer" @click="skip('/user/bill/list')">更多消费明细<i class="icon icon-next mar-l-xs"></i></span>
						</p>
						<div class="box">
							<div class="general-info flex-column flex-justify-center box" style="min-width: 35%;">
								<div class="general-item-box">
									<span class="">本月消费金额：</span>
									<span class="this-month color-price">{{(consume.thisMonth || 0)|money}}</span>
								</div>
								<div class="general-item-box pad-t-0">
									<span class="">上月消费金额：</span>
									<span class="last-month">{{(consume.lastMonth || 0)|money}}</span>
								</div>
							</div>
							<div class="general-info" style="width: 65%;">
								<div class="general-info-content echart-container" style="height: 160px;border:0">
									<div class="echart-content" v-show="showEchart === true">
										<div id="canvas-comsumed-sum" style="height:160px;width: 100%;"></div>
									</div>
									<div class="echart-content-loading" v-if="loading.echart === 'loading'" style="height:100%">
										<img :src="require('../../../../common/src/assets/image/loading.gif')" alt="">
									</div>
									<div class="echart-content-nodata" v-if="loading.echart === 'nodata'" style="height:100%">
										<i class="icon icon-nodata"></i>
										<span>暂无数据</span>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
				<div class="general-content">
					<div class="general-box">
						<div class="general-title">
							<div>
								<span class="mar-r-mini">资源与业务</span>
								<efly-select class="general-title-select" size="small" :data="resourceSelectTimeList" main="text" :value="resourceSelectTimeList[0]" @change="selectChange($event, 'resourceSelectTime')" ></efly-select>
							</div>
						</div>
						<div class="general-resource-box">
							<div class="general-resource-item" v-for="(item,idx) in resourceList" :key="idx" @click="skip(item.link)">
								<div class="general-resource-item-left">
									<img :src="require('../../../../common/src/assets/image/'+item.image)" alt="">
								</div>
								<div class="general-resource-item-right">
									<efly-tooltip :trigger="item.tipsCount > 0 ? 'show' : 'hide'" top="-42px" left="-22px" placement="top" type="danger">
										<p>{{item.name}}</p>
										<div slot="content">
											<p @click.stop="skip(item.link + '/'+ item.uuid + '?screen=uuid')">待续费：{{item.tipsCount}}个</p>
										</div>
									</efly-tooltip>
									<p class="mar-t-mini">共<img src="../../../../common/src/assets/image/load-sm.gif" class="mar-lr-xs" v-if="loading.resource === 'loading'">
										<span class="count" v-else>{{item.count}}</span>台</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="general-box-right">
				<div class="general-content" style="min-height: 454px;">
					<div class="general-box" style="height: 454px;">
						<p class="general-title">最新公告</p>
						<div class="general-info">
							<ul class="general-info-list" style="height: 329px;overflow: hidden;">
								<div v-if="loading.bulletin === 'havedata'">
									<li class="general-info-list-item cursor-pointer" v-for="(item,idx) in bulletinList" :key="idx" @click="skip('/user/message/detail/'+item.id+'/notice')">
										<p>{{item.title}}</p>
										<p class="text-secondary mar-t-xs font-small">{{item.createTime ? item.createTime.split(' ')[0] : '-'}}</p>
										<span v-if="item.topStatus == 1" class="info-text-top">置顶</span>
									</li>
								</div>
								<div class="text-align-center" v-if="loading.bulletin === 'loading'" style="height:100%">
										<img :src="require('../../../../common/src/assets/image/loading.gif')" alt="">
								</div>
								<div class="text-align-center" v-if="loading.bulletin === 'nodata'" style="height:100%">
									<i class="icon icon-nodata"></i>
									<p>暂无数据</p>
								</div>
							</ul>
							<div class="text-align-right">
								<efly-button size="small" class="btn-primary" @click="skip('/user/message/notice')">查看更多</efly-button>
							</div>
						</div>
					</div>
				</div>
				<div class="general-content" style="height: calc(100% - 494px);">
					<div class="general-box" style="height: 100%;">
						<p class="general-title">常用操作</p>
						<div class="general-info">
							<div class="box flex-wrap general-handle">
								<efly-button size="small" class="btn-primary-bg btn" @click="skip('/resource/vm/create')">创建云主机</efly-button>
								<efly-button size="small" class="btn-primary-bg btn" @click="skip('/resource/vpc/list')">VPC网络</efly-button>
								<efly-button size="small" class="btn-primary-bg btn" @click="skip('/user/bill/list')">资费记录</efly-button>
								<efly-button size="small" class="btn-primary-bg btn" @click="skip('/user/userOptlog/list')">操作日志</efly-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
    import General from "./general";

    export default General;
</script>
<style lang="scss">
.general-title-select {
	height: 37px;
	.efly-select-item .efly-select-item-label {
		line-height: 1.1;
	}
	.icon::before {
		height: 100%;
	}
}
</style>
<style lang="scss" scoped>
.general-container {
	overflow-y: auto;
}
.general-header {
	.general-header-user-account {

		.welcome {color: #676767;}
		.email {
			color: #646464;
			font-size: 22px;
			font-weight: 700;
		}
		.general-header-icon {
			.icon {
				font-size: 18px;
			}
			.efly-tooltip {
				margin-right: 20px;
			}
		}
	}
}


.color-price {
	color: #FF5400;
}
.tooltip-btn {
	padding: 6px 6px;
	display:inline-block;
	position: absolute;
	top: -1px;
	margin-left: 6px;
	border-radius: 0px 3px 3px 0px;
	box-shadow: 1px 0 5px 0 #d7d8d9;
	&.tooltip-btn-danger {
		background: #FFEDED;
		border: 1px solid #f56c6c;
		border-left: 1px solid #F0A1A1;
	}
	&.tooltip-btn-primary {
		background: #EBF2FA;
		border: 1px solid #009FEF ;
		border-left: 1px solid #bad0ff;
		color: #009FEF;
	}
}
.general-box-left {
	width: 70%;
}
.general-box-right {
	width: calc(30% - 20px);
	margin-left: 20px;
}
.this-month {font-size: 30px; font-weight: 700;}
.last-month {font-size: 20px; font-weight: 700;}
.btn-price,.btn-price:hover {
	background: #FF5A00;
	color: #fff;
	border: 0;
}
.btn-primary-bg,.btn-primary-bg:hover {
	background: #EBF2FA;
	color: #019DEB;
	border: 0;
}
.color-point {
	display: inline-block;
    width: 8px;
    height: 8px;
    background: #000;
    border-radius: 50%;
    line-height: -moz-block-height;
    top: -1px;
    position: relative;
}
.general-info-list {
	.general-info-list-item:not(:last-child) {
		margin-bottom: 30px;
	}
}
.general-handle {
	.btn {
		width: calc(50% - 5px);
		margin-bottom: 10px;

		&:nth-child(odd) {
			margin-right: 10px;
		}
	}
}
.general-resource-box {
	.general-resource-item {margin-bottom: 20px;}
}
.info-text-top {
	display: inline-block;
    position: relative;
	background: #4074e1;
    color: #fff;
    line-height: 12px;
    font-size: 12px;
    padding: 3px;
    border-radius: 5px;
}
</style>
